<div role="alert">
  <app-toast></app-toast>
</div>

<app-skip-to-main></app-skip-to-main>
<router-outlet></router-outlet>

<main *ngIf="isLoading$ | async" class="main-preloader">
  <app-content-preloader></app-content-preloader>
</main>
